import React from 'react';
import {
  DiscountIcon,
  FinanceIcon,
  LeadTimeIcon,
  MarginRangeIcon,
  MarkupIcon,
  PhoneIcon,
} from 'components/common/icons';
import { PERMISSIONS } from 'constants/permissions';
import { Col, EditableInfoComponent, Row, Typography } from 'components';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { usePricingRules } from './usePricingRules';
import { EditPricing } from './edit';

const { Text } = Typography;

export const SupplierPricingRules = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { pricingRules, onUpdateModalStateChange, updateModalState } = usePricingRules();
  return (
    <>
      <EditableInfoComponent
        title={'Pricing Rules'}
        editable={hasAccess(PERMISSIONS.suppliers.pricing_rules.write)}
        icon={<PhoneIcon />}
        onEdite={onUpdateModalStateChange}
      />
      <Row gutter={[0, 4]}>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Row align={'middle'} gutter={[4, 0]}>
                <MarkupIcon />
                <Col>
                  <Text type={'secondary'}>Margin</Text>
                </Col>
              </Row>
            </Col>
            <Col>
              <Text type="secondary">
                {typeof pricingRules?.markup === 'number' ? `${pricingRules.markup}%` : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Row align={'middle'} gutter={[4, 0]}>
                <MarginRangeIcon />
                <Col>
                  <Text type={'secondary'}>Margin Range</Text>
                </Col>
              </Row>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {pricingRules.minMargin && pricingRules.maxMargin
                  ? `${pricingRules.minMargin}-${pricingRules.maxMargin}%`
                  : pricingRules.minMargin
                    ? `${pricingRules.minMargin}% Min`
                    : pricingRules.maxMargin
                      ? `${pricingRules.maxMargin}% Max`
                      : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Row align={'middle'} gutter={[4, 0]}>
                <LeadTimeIcon />
                <Col>
                  <Text type={'secondary'}>Lead Time</Text>
                </Col>
              </Row>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {pricingRules.minLeadTime && pricingRules.maxLeadTime
                  ? `${pricingRules.minLeadTime}-${pricingRules.maxLeadTime} ${pricingRules.type === 'DAY' ? 'days' : 'weeks'}`
                  : pricingRules.minLeadTime
                    ? `Min ${pricingRules.minLeadTime} ${pricingRules.type === 'DAY' ? 'days' : 'weeks'}`
                    : pricingRules.maxLeadTime
                      ? `Max ${pricingRules.maxLeadTime} ${pricingRules.type === 'DAY' ? 'days' : 'weeks'}`
                      : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Row align={'middle'} gutter={[4, 0]}>
                <DiscountIcon />
                <Col>
                  <Text type={'secondary'}>Discount</Text>
                </Col>
              </Row>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {typeof pricingRules?.discount === 'number' ? `${pricingRules.discount}%` : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Row align={'middle'} gutter={[4, 0]}>
                <FinanceIcon />
                <Col>
                  <Text type={'secondary'}>Minimum Order Fee</Text>
                </Col>
              </Row>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {pricingRules?.minimumOrderFee ? `${pricingRules.minimumOrderFee}€` : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <EditPricing
        modalState={updateModalState}
        onModalStateChange={onUpdateModalStateChange}
        dataToEdit={pricingRules}
      />
    </>
  );
});
